(()=>{ 'use strict';
  const flag='__lavindeFoundationSheetDetailsV1';
  if(window[flag])return;
  window[flag]=1;

  const clean=value=>String(value||'').trim();

  const update=card=>{
    if(!card)return;
    const sheet=card.querySelector('[data-foundation-dialog]');
    if(!sheet)return;
    const active=card.querySelector('[data-foundation-swatch][aria-checked="true"]');
    const description=sheet.querySelector('[data-foundation-sheet-description]');
    if(description){
      const text=active&&active.dataset?clean(active.dataset.shadeDescription):'';
      description.textContent=text;
      description.hidden=!text;
    }
  };

  const init=root=>{
    const scope=root&&root.querySelectorAll?root:document;
    scope.querySelectorAll('[data-foundation-card]').forEach(update);
  };

  const schedule=card=>{
    setTimeout(()=>update(card),30);
    setTimeout(()=>update(card),140);
  };

  document.addEventListener('click',event=>{
    const target=event.target;
    if(!target||!target.closest)return;

    const swatch=target.closest('[data-foundation-swatch]');
    if(swatch){
      schedule(swatch.closest('[data-foundation-card]'));
      return;
    }

    const opener=target.closest('[data-foundation-selector-open]');
    if(opener){
      const productsRoot=opener.closest('[data-lavinde-homepage-products]');
      const card=opener.closest('[data-foundation-card]')||(productsRoot?productsRoot.querySelector('[data-foundation-card]'):null);
      schedule(card);
    }
  });

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',()=>init());
  }else{
    init();
  }

  document.addEventListener('shopify:section:load',event=>setTimeout(()=>init(event.target),80));
})();
